import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'em-colour-brick',
  styleUrls: ['./colour-brick.component.less'],
  templateUrl: './colour-brick.component.html',
  standalone: false,
})
export class ColourBrickComponent {
  @Input() public name = '';
  @Input() public red = '';
  @Input() public green = '';
  @Input() public blue = '';

  public get colour() {
    return `rgb(${this.red}, ${this.green}, ${this.blue})`;
  }
}
